export default "__VITE_ASSET__BqZBdjis__"